import React, { useState, useEffect, PureComponent } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import axios from "axios"; // if you prefer axios
import api from '../api'; 
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const geoUrl = "/map-geo.json";

console.log("geoUrl", geoUrl);

const stateData = {
  // ... your existing stateData
};
const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const IndiaMapComponent = () => {
  const [selectedState, setSelectedState] = useState(null);
  const [SelectedStateVal, setSelectedStateVal] = useState(null);
  const [apiData, setApiData] = useState(null);
  const data = selectedState ? stateData[selectedState] : null;
  useEffect(() => {
    if (selectedState) {
      // Example API endpoint - replace with your actual one
      const fetchData = async () => {
        try {
          const response = await api.get(
            `/cities/${encodeURIComponent(SelectedStateVal)}`
            );
          console.log("API Response:", response.data);
          setApiData(response.data);
        } catch (error) {
          console.error("API Error:", error);
          setApiData(null);
        }
      };
      fetchData();
    }
  }, [selectedState]);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", padding: "25px" }}>
    <ComposableMap
    projection="geoMercator"
    projectionConfig={{ scale: 1000, center: [80, 22] }}
    width={800}
    height={600}
    style={{ width: "70%", height: "auto" }}
    >
    <Geographies geography={geoUrl}>
    {({ geographies }) =>
    geographies.map((geo) => (

      <Geography
      key={geo.rsmKey}
      geography={geo}
      onClick={() => {
        console.log("Clicked:", geo.properties.st_nm, geo.properties.st_val);
        setSelectedState(geo.properties.st_nm || "Unknown");
        setSelectedStateVal(geo.properties.st_val || "Unknown");
      }}
      style={{
      default: {
        fill:
        selectedState === geo.properties.st_val
        ? "#4CAF50"
        : "#D6D6DA",
        stroke: "#607D8B",
        strokeWidth: 0.75,
      },
      hover: {
        fill: "#F53",
        stroke: "#607D8B",
        strokeWidth: 1,
      },
      pressed: {
        fill: "#E42",
        stroke: "#607D8B",
        strokeWidth: 1,
      },
    }}
    />
    ))
  }
  </Geographies>
  </ComposableMap>

  <div
  style={{
    width: "30%",
    padding: "1rem",
    fontSize: "1rem",
    background: "#f9f9f9",
    borderLeft: "1px solid #ddd",
  }}
  >
  <strong>Selected State:</strong>
  <p>{selectedState || "Click a state"}</p>

  {data ? (
    <table
    style={{
      width: "100%",
      marginTop: "1rem",
      borderCollapse: "collapse",
    }}
    >
    <tbody>
    <tr>
    <td><strong>Capital</strong></td>
    <td>{data.capital}</td>
    </tr>
    <tr>
    <td><strong>Population</strong></td>
    <td>{data.population}</td>
    </tr>
    <tr>
    <td><strong>GDP</strong></td>
    <td>{data.gdp}</td>
    </tr>
    </tbody>
    </table>
    ) : (
    <p style={{ marginTop: "1rem", fontStyle: "italic" }}>
    No data available for this state.
    </p>
    )}

    {apiData && (
      <div style={{ marginTop: "1rem" }}>
      <strong>API Info:</strong>
      <pre>{JSON.stringify(apiData, null, 2)}</pre>
      </div>
      )}
    </div>
    </div>
    );
};

export default IndiaMapComponent;